import { FORM_ERRORS } from '@cxc/core/consts';
import { keys } from 'lodash';

import { Injectable, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ErrorStore } from '@cxc/core/services';


@Injectable({ providedIn: 'root' })
export class FormService {
  errorStore = inject(ErrorStore);

  markAllAsDirty(form: FormGroup) {
    const controls = Object.keys(form.controls);

    controls.forEach(controlKey => {
      const control = form.controls[controlKey];

      if (control.invalid) {
        form.controls[controlKey].markAsDirty();
      }
    });
  }

  private _handleFormError(form: FormGroup<any>) {
    const controlsKeys = keys(form.controls);

    let hasMissingFields = false;
    let errorMessage = '';

    controlsKeys.forEach(key => {
      const control = form.controls[key];
      const errors = control.errors;

      // Prioritize showing required field error message
      if (hasMissingFields) {
        return;
      }

      // No errors
      if (!errors) {
        return;
      }

      if (errors['required']) {
        hasMissingFields = true;
        return;
      }

      // Grab first ocurring error
      if (errorMessage !== '') {
        return;
      }

      const errorKeys = keys(control.errors);

      errorMessage = errors[errorKeys[0]].errorMessage;
    });

    if (hasMissingFields) {
      this.errorStore.set(FORM_ERRORS.required);
      return;
    }

    if (errorMessage !== '') {
      this.errorStore.set(errorMessage);
      return;
    }
  }

  /**
   *
   *  Marks form as both touched and dirty if invalid.
   */
  trySubmitForm(form: FormGroup<any>) {
    if (form.invalid) {
      form.markAllAsTouched();
      this.markAllAsDirty(form);

      this._handleFormError(form);

      return true;
    }

    return false;
  }
}
